import useActionReducer from '@admin/hooks/use_action_reducer'
import RecordingField from './recordingfield'
import * as actions from './actions'
import PropTypes from 'prop-types'
import reducer from './reducer'
import React from 'react'

const RecordingFieldContainer = (props) => {

  const [state, handlers] = useActionReducer({
    display_name: 'reordingfield',
    actions,
    props,
    reducer
  })

  const mergedProps = {
    ...props,
    ...state,
    ...handlers
  }

  return <RecordingField { ...mergedProps } />

}

RecordingFieldContainer.propTypes = {}

export default RecordingFieldContainer
